import React from 'react';

// eslint-disable-next-line react/function-component-definition
export default (maxWidth = 110) => (x) => (
  <div
    style={{
      maxWidth,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }}
  >
    {x}
  </div>
);
